import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_CAMPAIGN] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.campaign = payload
  },
  [types.SET_CAMPAIGNS] (state, payload) {
    state.campaigns = payload.data
    state.pagination = payload.meta.pagination
  },
  [types.SET_CONTACTS] (state, payload) {
    state.contacts = payload.data
    state.paginationC = payload.meta.pagination
  }
}
